import React, { useEffect } from "react";
import { Container, Grid } from "@mui/material";
import { connect } from "react-redux";
import tmsActions from "../../../../actions/tmsActions";
import { getAccomplishments, isFetching } from "../../../../reducers";
import Fetching from "../../../Common/Fetching";
import { DataTypes } from "../../../../constants";
import AccomplishmentCard from "./AccomplishmentCard";
import PropTypes from "prop-types";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import FileSaver from "file-saver";

const appCode = 'C-TMS';

const MyAccomplishments = ({ isFetching, accomplishments, getAccomplishments, downloadCertificate }) => {
    useEffect(() => {
        getAccomplishments(appCode);
    }, [getAccomplishments]);

    const handleDownload = ({id, skill}) => downloadCertificate(appCode, id, (blob) => FileSaver.saveAs(blob, `${skill.certificate.name}.pdf`));

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12} >
                    <BreadcrumbBuilder />
                </Grid>

                {isFetching && (
                    <Grid item md={12}>
                        <Fetching />
                    </Grid>
                )}

                {!accomplishments ? null : accomplishments.map((row) => (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6} key={row.id} className="card-grid-item">
                        <AccomplishmentCard
                            accomplishment={row}
                            downloadAction={() => handleDownload(row)}
                        />
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

MyAccomplishments.propTypes = {
    isFetching: PropTypes.bool,
    accomplishments: PropTypes.array,
    downloadCertificate: PropTypes.func.isRequired,
    getAccomplishments: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    accomplishments: getAccomplishments(state),
    isFetching: isFetching(state, DataTypes.TMS_ACCOMPLISHMENTS),
});

export default connect(mapStateToProps, {
    getAccomplishments: tmsActions.getAccomplishments,
    downloadCertificate: tmsActions.downloadCertificate,
})(MyAccomplishments);
